"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const grid = {
    "gutter": "calc(1.6rem * var(--voca-rem-multiplier))",
    "gutterMedium": "calc(2.4rem * var(--voca-rem-multiplier))",
    "gutterLarge": "calc(2.4rem * var(--voca-rem-multiplier))",
    "pagePadding": "calc(1.6rem * var(--voca-rem-multiplier))",
    "pagePaddingM": "calc(2.4rem * var(--voca-rem-multiplier))",
    "pagePaddingL": "calc(4.8rem * var(--voca-rem-multiplier))",
    "pagePaddingXl": "calc(4.8rem * var(--voca-rem-multiplier))"
};
exports.default = grid;
